import { theme, DeprecatedAlertIcon, DeprecatedCommentWarningIcon } from '@arnold/common';
import styled from '@emotion/styled/macro';
import { AnswerType } from '../../lib/reports/question';

type IProps = {
  type: AnswerType;
};

const HightligthedIcon = styled.span`
  padding-right: ${theme.spacing.c};
  font-size: 14px;
`;

export const HighlightedAnswersIcon = ({ type }: IProps) => {
  const icon =
    type === AnswerType.ALERT ? (
      <DeprecatedAlertIcon />
    ) : type === AnswerType.WARNING ? (
      <DeprecatedCommentWarningIcon />
    ) : undefined;

  if (icon) {
    return <HightligthedIcon>{icon}</HightligthedIcon>;
  }

  return <></>;
};
